function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { tlsPrescriptionTrigger } from "core/utils/alert";
import dayjs from "dayjs";
import AlertTriggeredJournalEvent, { TlsPrescriptionTrigger } from "./alert-triggered-journal-event";
export default class TlsAlertModelView {
  constructor(alertTriggeredJournalEvent) {
    _defineProperty(this, "patientName", void 0);
    _defineProperty(this, "patientId", void 0);
    _defineProperty(this, "followUpReason", void 0);
    _defineProperty(this, "healthCentreName", void 0);
    _defineProperty(this, "referentMedicName", void 0);
    _defineProperty(this, "isRenewal", void 0);
    _defineProperty(this, "validityPeriod", void 0);
    _defineProperty(this, "id", void 0);
    this.alertTriggeredJournalEvent = alertTriggeredJournalEvent;
    const patient = alertTriggeredJournalEvent.patient;
    this.id = alertTriggeredJournalEvent.id;
    this.patientName = patient.fullName;
    this.patientId = patient.id;
    this.followUpReason = patient.followUpReason;
    this.healthCentreName = patient.healthCentre.name;
    this.referentMedicName = patient.referentMedic?.fullName;
    this.isRenewal = alertTriggeredJournalEvent.isTlsRenewal;
    this.validityPeriod = this.computeValidityDates();
  }
  isBefore(tlsAlert) {
    return dayjs(this.nextPrescriptionStartDate).isBefore(tlsAlert.nextPrescriptionStartDate) ? 1 : -1;
  }
  get nextPrescriptionStartDate() {
    return new Date(this.tlsPrescriptionTrigger.nextPrescriptionStartDate);
  }
  computeValidityDates() {
    const trigger = this.tlsPrescriptionTrigger;
    const startDate = new Date(trigger.nextPrescriptionStartDate);
    const endDate = new Date(trigger.nextPrescriptionEndDate);
    return startDate && endDate ? `Du ${startDate.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit"
    })} au ${endDate.toLocaleDateString("fr-FR")}` : "";
  }
  get tlsPrescriptionTrigger() {
    return tlsPrescriptionTrigger(this.alertTriggeredJournalEvent);
  }
}